import {BASE_URL} from "@/constants/config";
import {request} from "@/utils/request";

export const FONCTION_ENDPOINTS = {
  base: `${BASE_URL}api/fonctions/`,
  template: `${BASE_URL}api/fonctions/template/`,
  export: `${BASE_URL}api/fonctions/export/`,
  fonction: (id) => `${BASE_URL}api/fonctions/${id}/`,
  check: (code) => `${BASE_URL}api/fonctions/check/${code}/`,
};

class Fonction {
  async fetchFonctions(query) {
    const { data } = await request({
      url: FONCTION_ENDPOINTS.base,
      query,
    });
    return data;
  }

  async createFonction(payload){
    return await request({
      url: FONCTION_ENDPOINTS.base,
      method: "POST",
      body: payload,
    });
  }

  async updateFonction(id, payload){
    return await request({
      url: FONCTION_ENDPOINTS.fonction(id),
      method: "PATCH",
      body: payload,
    });
  }

  async deleteFonction(id){
    return await request({
      url: FONCTION_ENDPOINTS.base,
      body: id,
      method: "DELETE",
    });
  }

  async checkCode(code){
    return await request({
      url: FONCTION_ENDPOINTS.check(code),
    })
  }

}

export const FonctionService = new Fonction();
